import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface MemberCategoryMasterState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allMemberCategoryMasterList: any[]; 

}

const initialState: MemberCategoryMasterState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allMemberCategoryMasterList: [], 
};

export const memberCategoryMasterSlice = createSlice({
  name: 'memberCategoryMaster',
  initialState,
  reducers: {
    setMemberCategoryMaster: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setMemberCategoryMasterBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllMemberCategoryMaster: (state, action) => {
      state.allMemberCategoryMasterList = action.payload.data; // no pagination
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setMemberCategoryMaster,setMemberCategoryMasterBySearch, setAllMemberCategoryMaster ,reset } = memberCategoryMasterSlice.actions;
export const getMemberCategoryMasterDetails = (state: RootState) => state.memberCategoryMaster.data;
export const getMemberCategoryMasterBySearchDetails= (state: RootState) => state.memberCategoryMaster.data;
export const getMemberCategoryTotalRecords=(state:RootState)=>state.memberCategoryMaster.totalRecords;
export const getMemberCategoryMasterList = (state: RootState) => state.memberCategoryMaster.allMemberCategoryMasterList;
export default memberCategoryMasterSlice.reducer;